// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Array = require("rescript/lib/js/belt_Array.js");

function isEmpty(set) {
  return set.size === 0;
}

function isSubsetOf(aSet, bSet) {
  return Belt_Array.every(Array.from(aSet), (function (item) {
                return bSet.has(item);
              }));
}

function isStructSubsetOf(aSet, bSet) {
  if (isSubsetOf(aSet, bSet)) {
    return !isSubsetOf(bSet, aSet);
  } else {
    return false;
  }
}

function isSameSetAs(aSet, bSet) {
  if (isSubsetOf(aSet, bSet)) {
    return isSubsetOf(bSet, aSet);
  } else {
    return false;
  }
}

function intersect(aSet, bSet) {
  var jointed = [];
  aSet.forEach(function (item) {
        if (bSet.has(item)) {
          jointed.push(item);
          return ;
        }
        
      });
  return new Set(jointed);
}

function union(aSet, bSet) {
  var unioned = [];
  var addUnioned = function (item) {
    unioned.push(item);
    
  };
  aSet.forEach(addUnioned);
  bSet.forEach(function (item) {
        if (!aSet.has(item)) {
          return addUnioned(item);
        }
        
      });
  return new Set(unioned);
}

function subtract(aSet, bSet) {
  var diffs = [];
  aSet.forEach(function (item) {
        if (!bSet.has(item)) {
          diffs.push(item);
          return ;
        }
        
      });
  return new Set(diffs);
}

function difference(aSet, bSet) {
  return union(subtract(aSet, bSet), subtract(bSet, aSet));
}

exports.isEmpty = isEmpty;
exports.isSubsetOf = isSubsetOf;
exports.isStructSubsetOf = isStructSubsetOf;
exports.isSameSetAs = isSameSetAs;
exports.intersect = intersect;
exports.union = union;
exports.subtract = subtract;
exports.difference = difference;
/* No side effect */
